import React, { useContext } from 'react'
import { useEffect } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import FilterWrapper from './FilterWrapper';

/**
 * The `FundSector` function is a React component that renders a filter for selecting fund sectors,
 * with options that can be expanded or collapsed.
 * @returns a JSX element.
 */
function FundSector({ open, accordionClick, fundSectorOptions, setFundSectorOptions, customPathname,label="Sector" }) {

    const { FundSector, refineSearchFilters } = useContext(PeFilterContext);

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered whenever the dependencies (`FundSector`, `customPathname`,
    `refineSearchFilters`, `setFundSectorOptions`) change. */
    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.fundSector?.map(value => value.id) ?? [];
        setFundSectorOptions(FundSector?.map(industry => ({ ...industry, isChecked: industryIds.includes(parseInt(industry.id)) })))
    }, [FundSector, customPathname, refineSearchFilters, setFundSectorOptions])

    /* The `handleFundSectorChange` function is an event handler that is triggered when the user
    selects or deselects a fund sector option. It receives the event object `e` as a parameter. */
    const handleFundSectorChange = ((e) => {
        const { name, checked, id } = e.target;

        if (name === "allSelect") {
            let currentFundsector = fundSectorOptions.map((fund) =>
                ({ ...fund, isChecked: checked })
            );
            setFundSectorOptions(currentFundsector);
        } else {
            let currentFundsector = fundSectorOptions.map((fund) =>
                fund.id === parseInt(id) ? { ...fund, isChecked: checked } : fund
            );
            setFundSectorOptions(currentFundsector);
        }

    });

    const len = fundSectorOptions?.filter(option => option.isChecked)?.length ?? 0
    // console.log(len,'selected sector count');

    return (
        <div className="border-b-[3px] border-[#E8E6E1]">
            <li
                className={
                    open
                        ? "bg-white relative px-3 py-1"
                        : "relative px-3 py-1"
                }
            >
                <FilterWrapper
                    count={len}
                    isSelect={false}
                    label={label}
                    onClick={accordionClick}
                    open={open}
                />

                <div
                    className="relative overflow-hidden transition-all max-h-0 duration-700  overflow-y-auto no-scrollbar"
                    style={{ maxHeight: open ? "10rem" : "" }}
                >

                    {open === true ? <MultiSelectEntity
                        handleEntityChange={handleFundSectorChange}
                        primaryEntity={fundSectorOptions}
                    /> : <></>}

                </div>

            </li>

        </div>
    )
}

export default FundSector